<!--
 * @Author: 田鑫
 * @Date: 2022-01-06 10:28:21
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-13 21:17:17
 * @Description: 包间管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>包间管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="餐厅名称：" prop="canteenName">
          <el-input style="width: 300px" v-model="listParams.canteenName" placeholder="请填写餐厅名称"></el-input>
        </el-form-item>
        <el-form-item label="包间名称：" prop="roomName">
          <el-input style="width: 300px" v-model="listParams.roomName" placeholder="请填写包间名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog('')" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" border>
          <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />
          <el-table-column label="餐厅名称" prop="canteenName" align="center"></el-table-column>
          <el-table-column label="包间名称" prop="roomName" align="center"></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该包间吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="包间管理" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item label="包间名称：" prop="roomName">
          <el-input v-model="dialogForm.roomName" placeholder="请填写包间名称" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="包间容量：" prop="capacity">
          <el-input v-model="dialogForm.capacity" placeholder="例如：豪华包间可容纳20人聚餐，也可简单输入：20人" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属餐厅：" prop="canteenId">
          <el-select v-model="dialogForm.canteenId" placeholder="请选择餐厅" style="width: 100%">
            <el-option v-for="(item, index) in restaurantList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包间主图：" prop="mainPicture">
          <oss-uploader @setImage="getImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        canteenName: "",
        roomName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: {
        roomName: "",
        capacity: "",
        canteenId: "",
        mainPicture: "",
      },
      dialogRules: {
        roomName: [{ required: true, message: "请填写包间名称", trigger: "blur" }],
        capacity: [{ required: true, message: "请填写包间容量", trigger: "blur" }],
        canteenId: [{ required: true, message: "请选择餐厅", trigger: "change" }],
      },
      isDisabled: false,
      restaurantList: [],
      previewList: [],
    };
  },

  mounted() {
    this.loadTableData();
    this.loadRestaurantList();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/room",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    loadRestaurantList() {
      this.$http({
        url: global.apiUrl + "/canteen",
        method: "GET",
        params: {
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.restaurantList = res.body.data.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },

    /**
     * @description: 编辑包间
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + "/room/detail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            if (res.body.data.mainPicture) {
              console.log(res.body.data.mainPicture);
              this.previewList = [res.body.data.mainPicture];
            }
            this.openDialog(id);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除包间
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/room",
        method: "DELETE",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    openDialog(id) {
      if (id) {
        this.method = "PUT";
      } else {
        //* 还原表单
        this.dialogForm = this.$options.data().dialogForm;
        this.previewList = [];
        this.method = "POST";
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 获取图片
     * @param {*} file
     * @return {*}
     */
    getImage(file) {
      this.dialogForm.mainPicture = file;
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign(this.dialogForm);
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + "/room",
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                //* 还原表单
                this.dialogForm = this.$options.data().dialogForm;
                this.previewList = [];
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
